export default `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<path fill="currentColor" class="st0" d="M16.2,1.68c-0.63-0.28-1.22-0.32-1.77-0.1c-0.88,0.34-1.27,1.22-1.28,1.25L6.4,18l0.5,4.56l3.74-2.67
	l6.76-15.18C17.71,3.99,17.88,2.43,16.2,1.68z M7.57,21.04l-0.25-2.29l2.13,0.95L7.57,21.04z M10.09,19.06l-2.7-1.2l5.64-12.67
	l2.7,1.2L10.09,19.06z M16.63,4.37l-0.56,1.25l-2.7-1.2l0.56-1.25c0.06-0.13,0.63-1.3,1.94-0.72C17.16,3.03,16.68,4.24,16.63,4.37z"
	/>
</svg>`;
